import { RedactionForm } from "../../components/Forms/RedactionsForm";

const NewRedaction = () => {
  return <RedactionForm />;
};

export default NewRedaction;
